import React, { Component } from 'react';
import { Container, Popover, Button, TextField, Box, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

/**
 * Props:
 * - isOpen: boolean flag controlling popover visibility.
 * - availableLocations: array of merge target location names (current location excluded by caller).
 * - okCallback: function(selectedLocation) invoked when user confirms.
 * - cancelCallback: function() invoked when user cancels.
 */
export default class MergeLocationSelectPopover extends Component {

    styles = {
        button: {
            marginLeft: 10,
            marginRight: 10
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    };

    _okCallback;
    _cancelCallback;

    state = {
        selectedOption: null,
        inputValue: ''
    }

    constructor(props) {
        super(props);
        this._okCallback = props.okCallback;
        this._cancelCallback = props.cancelCallback;
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            // Reinitialize each time the popover opens so stale selection is not carried over.
            this._initializeSelectionFromProps();
        }
    }

    _initializeSelectionFromProps = () => {
        const availableLocations = this.props.availableLocations ? this.props.availableLocations : [];
        // Default to the first eligible location; caller has already filtered out current location.
        const selectedOption = availableLocations.length > 0 ? availableLocations[0] : null;

        this.setState({
            selectedOption: selectedOption,
            inputValue: selectedOption ? selectedOption : ''
        });
    }

    _okButtonPressed = () => {
        this._okCallback(this.state.selectedOption);
    }

    _cancelButtonPressed = () => {
        this._cancelCallback();
    }

    render() {
        const availableLocations = this.props.availableLocations ? this.props.availableLocations : [];

        let maxWidth = window.innerWidth * 0.5;
        if (maxWidth > 400)
            maxWidth = 400;

        return (
            <Popover open={this.props.isOpen}
                anchorReference="anchorPosition"
                anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
                transformOrigin={{vertical: 'center', horizontal: 'center'}}>
                <Box style={{margin: 20, width: maxWidth}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>Merge Into Location</Typography>
                    <div style={{marginTop: 15}}/>

                    <Autocomplete
                        size='small'
                        value={this.state.selectedOption}
                        onChange={(event, newValue) => {
                            // Keep selected option and visible text aligned after option selection.
                            this.setState({selectedOption: newValue, inputValue: newValue ? newValue : ''});
                        }}
                        inputValue={this.state.inputValue}
                        onInputChange={(event, newValue) => {
                            this.setState({inputValue: newValue});
                        }}
                        options={availableLocations}
                        style={{width: '100%'}}
                        blurOnSelect
                        openText="Select"
                        disableClearable={availableLocations.length > 0}
                        renderInput={(params) => (
                            <TextField {...params}
                                variant="outlined"
                            />
                        )}
                    />

                    <div style={{marginTop: 20}}/>
                    <Container style={this.styles.container}>
                        <Button onClick={this._okButtonPressed}
                            disabled={this.state.selectedOption == null}
                            color="primary"
                            variant="outlined"
                            style={this.styles.button}>OK</Button>
                        <Button onClick={this._cancelButtonPressed}
                            variant="outlined"
                            style={this.styles.button}>Cancel</Button>
                    </Container>
                </Box>
            </Popover>
        );
    }
}
